import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface NetworkListCustomerCellProps
  extends CellContext<GatewayNetworkModel, GatewayNetworkModel['customer']> {}

export const NetworkListCustomerCell = (
  props: NetworkListCustomerCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.CUSTOMER.DETAILS, {
            id: getValue()?.id,
          }),
        )
      }>
      <Text truncate>{getValue()?.name}</Text>
    </Link>
  );
};
